import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class GitCloneGitError extends GitError {
  constructor(url: string, append = true) {
    super(append ? `Failed to clone repository "${url}"` : url);
  }

  readonly gitErrorCode = GitErrorStatusCode.GitClone;
}
